var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    x: "0px",
    y: "0px",
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Layer0_0_1_STROKES",
    stroke: "#FFFFFF",
    strokeWidth: 0.8,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 1.05 1.8 L 2.25 1.8 6.175 1.8 7.35 1.8 M 6.175 1.8 Q 6.35625 1.80625 6.45 1.9 6.55 2.05 6.55 2.25 L 6.4 6.95 Q 6.4 7.3 6.15 7.55 5.9 7.8 5.6 7.8 L 2.8 7.8 Q 2.5 7.8 2.25 7.55 2 7.3 2 6.95 L 1.85 2.25 Q 1.85 1.80703125 2.25 1.8 M 5 6.05 L 5 3.5 M 3.4 6.05 L 3.4 3.5 M 3 0.5 L 5.4 0.5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_1_STROKES"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWhite);
export default __webpack_public_path__ + "static/media/delete-white.1f40d705cfa2e8316a3033363f24df08.svg";
export { ForwardRef as ReactComponent };